export enum BodyPart {
    Head = 'Head',
    Hand = 'Hand',
    Foot = 'Foot',
}
